import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webi-histo-update',
  templateUrl: './webi-histo-update.component.html',
  styleUrls: ['./webi-histo-update.component.css']
})
export class WebiHistoUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
